import React, { FC } from "react"
import styled from "styled-components"
import { TextBlock } from "../info-title/text-block"

const ShortDescriptionContainer = styled.section`
  width: 100%;
  background: #f6f7f8;
`

export const ShortDescription: FC<{ title: string; content: string }> = ({
  title,
  content,
}) => {
  return (
    <ShortDescriptionContainer>
      <TextBlock paddingTop={80} title={title} text={content} />
    </ShortDescriptionContainer>
  )
}
